import { useContext } from 'react';

import { ShopProviderContext } from './provider';

const useShopProvider = () => {
  const context = useContext(ShopProviderContext);
  if (!context) {
    throw new Error('ShopProvider not found');
  }
  return context;
};

export { useShopProvider };
